import { AxiosError } from "axios"

import { LoginLinkResponseError, RegisterLinkResponseError } from "./interfaces"
import { DEFAULT_ERROR_MESSAGE, LOGIN_ERROR } from "./constant"

import { getErrorDescription } from "modules/discount/getErrorDescription"

export const getErrorMessage = (
    error: AxiosError<LoginLinkResponseError | RegisterLinkResponseError>
) => {
    const errorResponse = error.response?.data
    if (!errorResponse) return DEFAULT_ERROR_MESSAGE
    if ("message" in errorResponse) {
        switch (errorResponse.message) {
            case LOGIN_ERROR.ClientAlreadyExists:
                return <>Пользователь с&nbsp;таким адресом электронной почты уже существует.</>
            case LOGIN_ERROR.ClientAlreadyAuthenticated:
                return <>Вы уже авторизованы.</>
            case LOGIN_ERROR.ClientNotFound:
                return (
                    <>
                        У&nbsp;нас нет такого адреса почты. Возможно, вы&nbsp;еще
                        не&nbsp;зарегистрировались.
                    </>
                )
        }
    }
    if ("promo_code" in errorResponse && errorResponse.promo_code) {
        return <>{getErrorDescription(errorResponse.promo_code[0])}</>
    }
    return DEFAULT_ERROR_MESSAGE
}
